import React from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { ConfirmationCheckbox, ScrollErrorForm } from 'components'
import PropTypes from 'prop-types'

const propTypes = {
  legaleseConfirmationForm: PropTypes.object.isRequired,
  formRef: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  taxable: PropTypes.bool,
}

const defaultProps = {}

function ParticipantUploadLegaleseSection({
  legaleseConfirmationForm,
  formRef,
  handleSubmit,
  taxable = false,
}) {
  return (
    <div className="form-section">
      <div className="form-header">
        <h3 className="is-marginless">
          Important information: review before continuing
        </h3>
      </div>
      {taxable ? (
        <p>
          Generally, we are unable to establish accounts for participants of
          terminating defined benefit plans, unless the plan is not covered by
          the Pension Benefit Guaranty Corporation (PBGC). This includes
          distributions made in contemplation of plan termination but before the
          formal commencement of termination proceedings. It is the Plan
          Fiduciary's responsibility to determine whether the plan is covered by
          the PBGC and whether participant accounts are eligible for rollover.
        </p>
      ) : (
        <p>
          Generally, participants of terminating defined benefit plans are not
          eligible for rollover, unless the plan is not covered by the Pension
          Benefit Guaranty Corporation (PBGC). This includes distributions made
          in contemplation of plan termination but before the formal
          commencement of termination proceedings. It is the Plan Fiduciary's
          responsibility to determine whether the plan is covered by the PBGC
          and whether participant accounts are eligible for rollover.
        </p>
      )}
      {!taxable && (
        <p>
          Active defined benefit and active defined contribution plan
          participant accounts may be eligible for rollover when the present
          value of the participant's nonforfeitable accrued benefit does not
          exceed $7,000. In limited circumstances, accounts with accrued
          benefits above $7,000 may be eligible for rollover. It is the Plan
          Fiduciary's responsibility to determine eligibility for each
          participant.
        </p>
      )}
      <Formik
        initialValues={{
          confirm: false,
          ...legaleseConfirmationForm,
        }}
        onSubmit={handleSubmit}
        validationSchema={Yup.object({
          confirm: Yup.boolean().required('Required').oneOf([true], 'Required'),
        })}
        innerRef={formRef}
      >
        <ScrollErrorForm>
          <ConfirmationCheckbox
            name="confirm"
            label="I acknowledge that I have read and understand the information above."
          />
        </ScrollErrorForm>
      </Formik>
    </div>
  )
}
ParticipantUploadLegaleseSection.propTypes = propTypes
ParticipantUploadLegaleseSection.defaultProps = defaultProps

export default ParticipantUploadLegaleseSection
